/** @jsxImportSource theme-ui */
import Image from "next/image"
import BlueHamburger from "../../../public/img/hamburger-blue.svg"
import CreamHamburger from "../../../public/img/hamburger-cream.svg"
import BlueCloseNav from "../../../public/img/close-nav-blue.svg"
import CreamCloseNav from "../../../public/img/close-nav-cream.svg"

interface NavToggleProps {
  theme: "BLUE" | "CREAM"
  isOpen: boolean
  handleToggle: () => void
}
const NavToggle = ({ theme, isOpen, handleToggle }: NavToggleProps) => {
  const hamburgerImage = theme === "BLUE" ? BlueHamburger : CreamHamburger
  const closeNavImage = theme === "BLUE" ? BlueCloseNav : CreamCloseNav

  return (
    <div
      sx={{
        ml: "auto",
        display: ["block", null, "none"],
        ":hover": {
          cursor: "pointer"
        }
      }}
      onClick={handleToggle}
    >
      {isOpen ? (
        <Image
          src={closeNavImage}
          alt="close nav button"
          layout="fixed"
          width={18}
          height={12}
        />
      ) : (
        <Image
          src={hamburgerImage}
          alt="nav toggle button"
          layout="fixed"
          width={18}
          height={12}
        />
      )}
    </div>
  )
}

export default NavToggle
